export default __webpack_public_path__ + "static/media/file@2x.020c5b4f.png";